import { Plus, Minus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { useCart } from '@/contexts/CartContext';
import { toast } from 'sonner';

const MenuItem = ({ item }) => {
  const { cart, addToCart, updateQuantity } = useCart();
  const cartItem = cart.find(cartItem => cartItem.id === item.id);
  const quantity = cartItem ? cartItem.quantity : 0;

  const handleAdd = () => {
    addToCart(item);
    toast.success(`${item.name} added to cart`);
  };

  const handleIncrement = () => {
    updateQuantity(item.id, quantity + 1);
  };

  const handleDecrement = () => {
    updateQuantity(item.id, quantity - 1);
    if (quantity === 1) {
      toast.success(`${item.name} removed from cart`);
    }
  };

  return (
    <Card className="group overflow-hidden bg-gradient-to-br from-gray-800 to-gray-900 border-2 border-amber-500/30 hover:border-amber-500 hover:shadow-xl hover:shadow-amber-500/20 transition-all duration-300">
      <div className="p-4 space-y-3">
        <div className="flex justify-between items-start gap-3">
          <div className="flex-1">
            <h4 className="font-semibold text-amber-100 text-base leading-tight group-hover:text-amber-400 transition-colors">
              {item.name}
            </h4>
            {item.description && (
              <p className="text-xs text-gray-400 mt-1 line-clamp-2">{item.description}</p>
            )}
          </div>
          <div className="bg-gradient-to-br from-amber-500 to-orange-600 text-white px-3 py-1.5 rounded-lg font-bold text-base shadow-md">
            ₹{item.price}
          </div>
        </div>

        {quantity === 0 ? (
          <Button
            onClick={handleAdd}
            className="w-full bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white font-semibold shadow-lg"
          >
            <Plus className="w-4 h-4 mr-2" />
            Add to Cart
          </Button>
        ) : (
          <div className="flex items-center justify-between bg-gradient-to-r from-orange-500 to-red-600 text-white rounded-lg p-1 shadow-md">
            <Button onClick={handleDecrement} size="sm" variant="ghost" className="h-8 w-8 p-0 hover:bg-white/20">
              <Minus className="w-4 h-4" />
            </Button>
            <span className="font-bold text-lg px-4">{quantity}</span>
            <Button onClick={handleIncrement} size="sm" variant="ghost" className="h-8 w-8 p-0 hover:bg-white/20">
              <Plus className="w-4 h-4" />
            </Button>
          </div>
        )}
      </div>
    </Card>
  );
};

export default MenuItem;
